import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {formatCurrency} from '../utils/currency';
import {formatNumber} from '../utils/number';

class CheckoutCta extends Component {
  render() {
    return this.props.total ?
      (
        <div className={`shopping-cart__cta ${this.props.className || ''}`}>

          {
            this.props.isFreeShipping &&

              <div className="shopping-cart__cta__free-shipping">
                <i className="shopping-cart__cta__free-shipping__icon icon-check"/> Your order qualifies for FREE Shipping.<br />
                  <a href={`${ROOT_URL}/cms/17`} target="_blank">Details</a>
              </div>
          }

          <div className="shopping-cart__cta__body">
            <h3><span className="shopping-cart__cta__label">Subtotal ({formatNumber(this.props.total)} {this.props.total === 1 ? 'item' : 'items'}): </span>
              <span className="shopping-cart__cta__amount">{formatCurrency(this.props.subtotal)}</span></h3>
            <a href={`${ROOT_URL}/checkout`} className="button primary shopping-cart__cta__button -full" onClick={window.showLoadingIndicator}>
              <i className="icon-lock"/><span> Proceed to checkout</span></a>
          </div>

          <div className="shopping-cart__cta__quote">
            <a href={`${ROOT_URL}/create-quote`} onClick={window.showLoadingIndicator} className="button -gray shopping-cart__cta__button tiny">
              <span>Create quote</span>
            </a>
          </div>

        </div>
      )

      : null;
  }
}

CheckoutCta.propTypes = {
  isFreeShipping: PropTypes.bool.isRequired,
  subtotal: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default CheckoutCta;
